import { render, staticRenderFns } from "./Mybusiness.vue?vue&type=template&id=a15b27da&scoped=true&"
import script from "./Mybusiness.vue?vue&type=script&lang=js&"
export * from "./Mybusiness.vue?vue&type=script&lang=js&"
import style0 from "./Mybusiness.vue?vue&type=style&index=0&id=a15b27da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15b27da",
  null
  
)

export default component.exports